import React, { useEffect } from "react";
import { useStore } from "../../store";
import { Button, Modal, Switch, Spin, message } from "antd";
import "./settings.scss";
import { useState } from "react";
import { useSettings } from "../../custom-hooks/useSettings";

// name -> name to display   
// key -> key from settings api result
// key2 -> key in PUT request to update Site Features 

export default function MicrositeSettingsCopy({ activeKey, open, closeSettings }) {
    const { updateSettings, settingsUpdateLoader, getSettings } = useSettings();
    const { settings } = useStore();

    const [checker, setChecker] = useState();
    const [allLoader, setAllLoader] = useState(true);
    const [allChecker, setAllChecker] = useState(false);


    const settingsItem = settings


    const updatedState = () => {
        const temp = settingsItem.map(item => ({
            ...item,
            name: item?.displayName,
            // switchStatus: settings[item.key] || false
            switchStatus: item?.primaryToggle,

        }));

        setChecker(temp)
    }

    useEffect(() => {
        if (activeKey) {
            getSettings(activeKey);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeKey]);

    useEffect(() => {
        setAllLoader(true);
        updatedState();
        setAllLoader(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings]);

    useEffect(() => {
        let anyTrue = true;
        for (let item in checker) {
            if (!checker[item].secondaryToggle) {
                anyTrue = false
                break;
            }
        }
        setAllChecker(anyTrue);
    }, [checker])


    const handleChecker = (isChecked, key) => {
        const updatedChecker = checker.map(item => {
            if (item.displayName === key) {
                return {
                    ...item,
                    name: item?.displayName,
                    switchStatus: isChecked,
                    secondaryToggle: isChecked,

                };
            }
            return item;
        });
        setChecker(updatedChecker);
    }

    const handleAllToggle = (isChecked) => {
        setAllLoader(true);
        const temp = settingsItem.map(item => ({
            ...item,
            name: item?.displayName,
            secondaryToggle: isChecked,
            // switchStatus: isChecked,
        }));

        setChecker(temp);
        setAllLoader(false)
    }



    const submit = () => {
        // checker.forEach(item => {
        //     dataObject[item.key2] = item.switchStatus;
        // });
        // updateSettings(activeKey, { settings: dataObject });
        const payload = checker.map(item => {
            return {
                id: item?.id,
                secondaryToggle: item?.secondaryToggle
            }
        })
        updateSettings(activeKey, [...payload]);

        closeSettings();
    };

    return (
        <div className="">
            <Modal open={open} footer={null} width="400px" style={{ top: "40px" }} closable={false} onCancel={closeSettings}>
                {(allLoader || settingsUpdateLoader) ? <div className="data-loader">
                    <Spin tip="Loading" size="large" />
                </div> :
                    <>
                        <div className="header">
                            <div className="ms-settings-header settings-header">Site Features</div>
                            <div className="all-switch">
                                <Switch
                                    className="siteSetting-switch"
                                    checked={allChecker}
                                    onChange={(e) => handleAllToggle(e)}
                                />
                            </div>
                        </div>
                        {checker && checker?.length > 0 ?
                            <>
                                <div className="ms-settings">
                                    {checker && checker.map((d, i) => {
                                        return (
                                            <>

                                                <div className="ms-settings-row">
                                                    <div className="ms-settings-label">{d?.name}</div>
                                                    <div className="ms-settings-switch">
                                                        <Switch
                                                            className="siteSetting-switch"
                                                            // defaultChecked={
                                                            //     checker && checker[d.key] ? checker[d.key] : false
                                                            // } 
                                                            checked={d?.secondaryToggle}
                                                            // checked={false}

                                                            // defaultChecked={d.switchStatus}
                                                            // onChange={(e) => handleChecker(e, d?.displayName)}
                                                            onChange={(e) => {
                                                                if(e && !d?.isDataPresent){
                                                                    message.warn('This tab will not appear to users until the data has been added')
                                                                }
                                                                handleChecker(e, d?.displayName)
                                                            }}

                                                        />
                                                    </div>
                                                </div>


                                            </>

                                        );
                                    })}
                                </div>
                                <div className="ms-settings-footer">
                                    <div className="ms-settings-footer-sub">
                                        <Button className="cancelBtn" onClick={closeSettings}>
                                            Cancel
                                        </Button>
                                        <Button
                                            className="greenBtn"
                                            onClick={submit}
                                            loading={settingsUpdateLoader}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </>
                            : <>
                                <div>Spinning</div>
                            </>
                        }
                    </>
                }
            </Modal>
        </div>
    );
}